import { NgModule } from '@angular/core';
import { LoginPageComponent } from './features/auth/login-page/login-page.component';
import { RouterModule, Routes } from '@angular/router';
import { LoggedInAuthGuard } from './core/guard/logged-in-auth.guard';
import { AuthGuard } from './core/guard/auth.guard';
import { ForgetPasswordComponent } from './features/auth/forget-password/forget-password.component';
import { ResetPasswordComponent } from './features/auth/reset-password/reset-password.component';
import { UnsubscribeComponent } from './features/auth/unsubscribe/unsubscribe.component';
import { MainLayoutComponent } from './layout/main-layout/main-layout.component';

const routes: Routes = [
  {
    path: '',
    component: LoginPageComponent,
    canActivate: [LoggedInAuthGuard],
  },
  {
    path: 'forget-password',
    component: ForgetPasswordComponent,
  },
  {
    path: 'reset-password/:token',
    component: ResetPasswordComponent,
  },
  {
    path: 'unsubscribe/:email',
    component: UnsubscribeComponent,
  },
  {
    path: '',
    component: MainLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      {
        path: 'catalogs',
        loadComponent: () =>
          import('./pages/catalogs/catalogs.component').then((m) => m.CatalogsComponent),
      },
      {
        path: 'catalogs/:id/products',
        loadComponent: () =>
          import('./pages/catalogs/products/products.component').then((m) => m.ProductsComponent),
      },
      {
        path: 'cart',
        loadComponent: () => import('./pages/cart/cart.component').then((m) => m.CartComponent),
      },
      {
        path: 'orders',
        loadComponent: () =>
          import('./pages/orders/orders.component').then((m) => m.OrdersComponent),
      },
      {
        path: 'orders/:id',
        loadComponent: () =>
          import('./pages/orders/order/order.component').then((m) => m.OrderComponent),
      },
      {
        path: 'orders/:orderId/catalog/:catalogId/add-products',
        loadComponent: () =>
          import('./pages/orders/order/add-products/add-products.component').then(
            (m) => m.AddProductsComponent
          ),
      },
    ],
  },
  // {
  //   path: 'pages',
  //   component: MainComponent,
  //   canActivate: [AuthGuard],
  //   children: [
  //     {
  //       path: '',
  //       redirectTo: 'catalogs',
  //       pathMatch: 'full',
  //     },
  //     {
  //       path: 'catalogs',
  //       component: ListCatalogsComponent,
  //     },
  //     {
  //       path: 'wishlist',
  //       component: ListWishlistComponent,
  //     },
  //     {
  //       path: 'quotes',
  //       component: ListQuotesComponent,
  //     },
  //     {
  //       path: 'orders',
  //       component: ListOrdersComponent,
  //     },
  //     {
  //       path: 'products/:id',
  //       component: ProductsComponent,
  //     },
  //     {
  //       path: 'quote-main/:id',
  //       component: MainQuotesComponent,
  //     },
  //     {
  //       path: 'details-orders/:id',
  //       component: MainQuotesComponent,
  //     },
  //   ],
  // },
];

@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled', // scrolls to top on navigation
      anchorScrolling: 'enabled', // scrolls to anchors when using #id links
    }),
  ],
  exports: [RouterModule],
})
export class AppRoutingModule {}
